import React, { lazy, MutableRefObject, Suspense, useEffect, useRef } from 'react';
import './App.scss'
import Nav from './components/Navigator'
import Pin from './components/Pin'
import Loading from './pages/loading'

import { HashRouter as Router, Switch, Route, Redirect } from 'react-router-dom'

const routes = [
  {
    path: "/",
    name: "公司简介",
    component: lazy(() => (import('./pages/intro')))
  },
  // {
  //   path: "/welfare",
  //   name: "员工福利",
  //   component: lazy(() => (import('./pages/bene')))
  // },
  {
    path: "/process",
    name: "校招流程",
    component: lazy(() => (import('./pages/proc')))
  },
  {
    path: "/resume",
    name: "简历投递",
    component: lazy(() => (import('./pages/send')))
  }
]

const App = () => {
  return (
    <div id="App">
      <Router>
        <Route component={() => (<Nav list={routes} />)} />
        <Suspense fallback={<Loading />}>
          <Switch>
            {
              routes.map(p => (
                <Route exact path={p.path} key={p.name} component={p.component} />
              ))
            }
            <Redirect to="/" />
          </Switch>
        </Suspense>

      </Router>
      <Pin />
    </div>
  );
}

export default App;
